import { useCoreStore } from './useCoreStore'

export const isCanadianBrand = (): boolean =>
  useCoreStore().activeBrand?.country === 'CA'
